import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";

// types
import { CompanyNoticeProps } from "../../model/company/Notice";

// components
import PageControl from "../../components/PageControl";

// images
import noImg02 from "../../images/common/noimg02.png";
import { Helmet } from "react-helmet-async";

// Styles
const Container = styled.div`
    .tab_wrap {
        display: flex;
        width: fit-content;
        border: 1px solid var(--subColor05);
        margin-left: auto;
        margin-right: auto;
    }

    .tab_wrap .tab_item .btn_tab {
        width: 207px;
        height: 70px;
    }

    .tab_wrap .tab_item:not(:last-of-type) .btn_tab {
        border-right: 1px solid var(--subColor05);
    }

    .tab_wrap .tab_item .btn_tab.on {
        color: #fff;
        background-color: var(--main_color03);
    }

    .product_list_wrap .product_count .num {
        color: var(--main_color03);
    }

    .product_list_wrap .product_wrap {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 48px 32px;
    }
    .product_list_wrap .product_wrap .product_item .product_tit {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }
    .btn_link:hover > .icon_search_wrap.type01,
    .btn_link:focus > .icon_search_wrap.type01 {
        display: flex;
    }

    .btn_link.type-search-wrap {
        position: relative;
    }

    .icon_search_wrap.type01 {
        display: none;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .product_list_wrap .product_wrap .thumbnail {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }
    .product_list_wrap .product_wrap .btn_link {
        overflow: hidden;
        width: 100%;
        height: 304px;
        border: 1px solid var(--subColor05);
        border-radius: 16px;
    }
    .product_list_wrap .product_wrap .category_wrap {
        display: flex;
        gap: 8px;
    }

    .product_list_wrap .product_wrap .category_wrap .category {
        border: 1px solid var(--pointColor01);
        border-radius: 9999px;
        color: var(--pointColor01);
    }
    /* @media screen and (max-width:1280px){
      .product_list_wrap {
         .product_wrap {
            .thumbnail{
               height: 220px;
            }
         }
      }
   } */
    @media screen and (max-width: 767px) {
        .product_list_wrap .product_wrap .btn_link {
            height: 220px;
        }
    }
`;

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const CertifiedCompany = () => {
    // API
    const query = useQuery();
    const page = query.get("page");
    const search = query.get("search");

    const [data, setData] = useState<CompanyNoticeProps>();
    const [loading, setLoading] = useState(true);

    const [searchTerm, setSearchTerm] = useState(search ? search : "");
    const [searchTermWrap, setSearchTermWrap] = useState(search ? search : "");
    const [pageIndex, setPageIndex] = useState(page ? page : 1);

    const navigate = useNavigate();

    const handleChange = (event: any) => {
        setSearchTermWrap(event.target.value);
    };

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const regex = /^[a-zA-Z0-9가-힣\s]*$/;

        if (!regex.test(searchTermWrap)) {
            alert("영문[대소문자], 한글[자음+모음], 숫자로 입력해주세요");
            return;
        }

        setPageIndex(1);
        setSearchTerm(searchTermWrap);
        setLoading(true);
        navigate(`?page=${pageIndex}&search=${searchTermWrap}`);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/company?page=${pageIndex}&search=${searchTerm}`
                );
                setData(response.data.data);
                if (response.data.success === false) {
                    alert(response.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        navigate(`?page=${pageIndex}&search=${searchTerm}`);
    }, [searchTerm, pageIndex]);

    return (
        <Container>
            <Helmet>
                <meta
                    name="keywords"
                    content="우수조달제품인증, 성능인증, 다수공급자계약, 신제품인증(NEP), 신기술인증(NET), 혁신제품, 벤처기업인증, 조달,경영인증 ,인증컨설팅"
                />
            </Helmet>
            <div className="top_nav type_01 container xl:mt-80">
                <p className="text_count xl:text-18 xl:mt-0 mt-40">
                    총 {data && <strong className="point">{data.total}</strong>}개의 게시물
                </p>
                <form className="search_from" onSubmit={handleSubmit}>
                    <fieldset>
                        <legend className="hide">검색</legend>
                        <div className="search_box">
                            <input
                                id="search"
                                type="search"
                                name="search"
                                placeholder="검색어를 입력하세요"
                                value={searchTermWrap}
                                onChange={handleChange}
                            />
                            <button onClick={handleSubmit} type="button">
                                <i className="xi-search icon_search" />
                            </button>
                        </div>
                    </fieldset>
                </form>
            </div>
            <div className="container xl:mb-48">
                <div className="product_list_wrap">
                    <ul className="product_wrap grid xl:mt-24 mt-16">
                        {data && !loading ? (
                            data.data.map((data, index) => (
                                <li className="product_item" key={index}>
                                    <Link
                                        to={`./${data.id}?page=${pageIndex}&search=${searchTerm}`}
                                        className="btn_link type-search-wrap xl:mb-24 mb-16"
                                    >
                                        <img
                                            className="thumbnail"
                                            src={data.image ? data.image : noImg02}
                                            alt="썸네일"
                                        />
                                        <div className="icon_search_wrap type01">
                                            <i className="xi-search xl:text-44 text-white"></i>
                                        </div>
                                    </Link>
                                    <div className="category_wrap">
                                        <div className="category leading-1em xl:text-16 text-12 font-bold xl:pt-8 xl:pr-16 xl:pb-8 xl:pl-16 pt-8 pb-8 pl-16 pr-16">
                                            {data.filter}
                                        </div>
                                    </div>
                                    <h5 className="product_tit xl:text-20 text-16 font-bold xl:mt-10 mt-8">
                                        {data.title}
                                    </h5>
                                    <p className="date leading-1em xl:text-16 text-14 xl:mt-16 mt-8 text-subColor04">
                                        {data.created_at_formatted}
                                    </p>
                                </li>
                            ))
                        ) : (
                            <li className="icon_loading_wrap">
                                <i className="xi-spinner-2 xi-spin"></i>
                            </li>
                        )}
                        {data && !loading && data.total === 0 && <li>게시글이 없습니다.</li>}
                    </ul>
                </div>
                {data && (
                    <PageControl data={data} pageIndex={pageIndex} setPageIndex={setPageIndex} loading={loading} />
                )}
            </div>
        </Container>
    );
};

export default CertifiedCompany;
